// eslint-disable-next-line max-classes-per-file
import { AdapterRegistry } from 'app/model/adapters/adapter-registry';
import { Model } from 'app/model/backendmodel';
import { Metamodel } from 'app/model/base/model';
import _ from 'lodash';
import { AirflowActivity } from 'app/model/pipeline/airflow.activity';
import { ValueAdapter } from 'app/model/adapters/value.adapter';
import { ActivityAsyncAdapter } from '../activity.adapter';
import { FabricAirflowLinkedService, ReferenceAdapter } from 'shell-models-lib';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(AirflowActivity),
    asynchronous: true,
    adapts: {
        name: '*',
        type: '*',
        description: '*',
        linkedServiceName: '*',
        dependsOn: '*',
        policy: '*',
        userProperties: '*',
        typeProperties: '*'
    }
})
export class AirflowActivityAdapter extends ActivityAsyncAdapter<AirflowActivity, Model.AirflowActivity> {
    protected async _toResource(activity: AirflowActivity): Promise<Model.AirflowActivity> {
        const modelActivity: Model.AirflowActivity = super._getCommonActivityProperties(
            activity,
            Metamodel.modelOf(activity).name
        ) as Model.AirflowActivity;

        modelActivity.typeProperties = {
            workspaceId: ValueAdapter.toResource(activity, AirflowActivity.WORKSPACE_ID),
            airflowId: ValueAdapter.toResource(activity, AirflowActivity.AIRFLOW_ID),
            dagId: ValueAdapter.toResource(activity, AirflowActivity.DAG_ID),
            waitOnCompletion: activity.waitOnCompletion
        };

        modelActivity.linkedServiceName = activity.airflowLinkedService
            ? this._toLinkedServiceReferenceModel(activity.airflowLinkedService)
            : undefined;

        if (activity.raw) {
            const parsed = JSON.parse(activity.raw);
            _.merge(modelActivity, parsed);
        }

        return modelActivity;
    }

    protected async _toModel(modelActivity: Model.AirflowActivity): Promise<AirflowActivity> {
        const activity: AirflowActivity = AirflowActivity.MODEL.create<AirflowActivity>(modelActivity.name);
        this._updatedCommonProperties(modelActivity, activity);

        const typeProperties = modelActivity.typeProperties ?? {};
        ValueAdapter.toModel(activity, AirflowActivity.WORKSPACE_ID, typeProperties.workspaceId);
        ValueAdapter.toModel(activity, AirflowActivity.AIRFLOW_ID, typeProperties.airflowId);
        ValueAdapter.toModel(activity, AirflowActivity.DAG_ID, typeProperties.dagId);
        activity.waitOnCompletion = typeProperties.waitOnCompletion ?? true;

        if (modelActivity.linkedServiceName) {
            activity.airflowLinkedService = ReferenceAdapter.toProxyModel<FabricAirflowLinkedService>(
                Metamodel.modelFor(FabricAirflowLinkedService),
                modelActivity.linkedServiceName,
                this.context
            );
        }

        activity.raw = JSON.stringify(await ValueAdapter.remainder(this.context, modelActivity, AirflowActivity.MODEL));
        return activity;
    }
}
